// Notification-related types

export enum NotificationType {
  System = 0,
  ProductUpdate = 1,
  ProductPublished = 2,
  WorkflowEvent = 3,
  WorkflowComplete = 4,
  WorkflowError = 5,
  WorkflowConflict = 6,
  PartnerInvite = 7,
  PartnershipAccepted = 8,
  ScheduleComplete = 9,
  ScheduleError = 10,
  ConnectionError = 11,
  ConnectionExpired = 12,
  UserInvite = 13,
  OrgMembershipChanged = 14,
  SubscriptionCreated = 15,
  SubscriptionUpdated = 16,
  Alert = 17,
}

export enum NotificationSeverity {
  Info = 0,
  Success = 1,
  Warning = 2,
  Error = 3,
}

export enum NotificationCategory {
  System = 0,
  Workflow = 1,
  Product = 2,
  Organization = 3,
  Account = 4,
  Connection = 5,
  Schedule = 6,
}

export interface Notification {
  id: string;
  userId: string;
  orgId: string;
  type: NotificationType;
  title: string;
  message: string;
  actionUrl?: string;
  actionText?: string;
  severity: NotificationSeverity;
  category: NotificationCategory;
  isRead: boolean;
  readAt?: string;
  createdAt: string;
  expiresAt?: string;
  metadata?: Record<string, any>;
}

export interface NotificationQueryParams {
  isRead?: boolean;
  category?: NotificationCategory;
  severity?: NotificationSeverity;
  page?: number;
  pageSize?: number;
}

export interface CreateNotificationRequest {
  userId: string;
  orgId: string;
  type: NotificationType;
  title: string;
  message: string;
  severity?: NotificationSeverity;
  category?: NotificationCategory;
  actionUrl?: string;
  actionText?: string;
  metadata?: Record<string, any>;
  expiresAt?: string;
}

export interface UnreadCountResponse {
  count: number;
}
